import React, { useEffect, useRef, useState } from "react";


export function useAnimationOnScroll<T extends Element>(
    options: IntersectionObserverInit = {
        threshold: 0.1,
    },
    once = true
): [React.RefObject<T>, boolean] {
    const ref = useRef<T>(null);

    const [hasAnimated, setHasAnimated] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                setHasAnimated(true);
                if (once) observer.disconnect();
            }
        }, options);
        const current = ref.current;
        if (current) observer.observe(current);

        return () => observer.disconnect();
    }, []);

    return [ref, hasAnimated];
}